<script>
export default {
  name: 'SecondHandSalesCumulatives',
}
</script>

<template>
  <div>SecondHandSalesCumulatives</div>
</template>
